import { api } from 'redux/api/index.api';
import { getNameFromContentDisposition } from 'utils/request';

export const observationsApi = api.injectEndpoints({
  endpoints: builder => ({
    fetchObservationLinkedItems: builder.query({
      query: ({ projectId, ids }) => ({
        url: `projects/${projectId}/observations/linked-items`,
        method: 'POST',
        body: JSON.stringify({ ids }),
      }),
      transformResponse: response =>
        response.values.map(value => ({
          ...value,
          isDeleted: value?.is_deleted,
          moduleId: value?.module_id,
          statusColor: value?.color,
          num: value?.legacy_id,
        })),
    }),
    fetchCommonObservation: builder.query({
      query: ({ projectId, commonObservationId }) => ({
        url: `projects/${projectId}/common-observations/${commonObservationId}`,
        method: 'GET',
      }),
    }),
    importObservations: builder.mutation({
      async queryFn({ projectId, moduleId, mediaId }, _queryApi, _extraOptions, baseQuery) {
        const result = await baseQuery({
          url: `projects/${projectId}/import/observations/module/${moduleId}`,
          method: 'POST',
          body: {
            media_id: mediaId,
            parent_id: moduleId,
          },
        });

        if (result.error) return { error: result.error };
        return { data: result.data };
      },
    }),
    downloadObservationsImportTemplate: builder.mutation({
      async queryFn({ projectId, moduleId }, _queryApi, _extraOptions, baseQuery) {
        const result = await baseQuery({
          url: `projects/${projectId}/import/template/observations/module/${moduleId}`,
          method: 'GET',
          responseHandler: response => response.blob(),
        });

        if (result.error) return { error: result.error };
        const blob = result.data;
        const headers = result?.meta?.response?.headers;
        const filename = headers?.get('content-disposition')
          ? getNameFromContentDisposition(headers)
          : 'template.xlsx';
        return { data: { blob, filename } };
      },
    }),
  }),
  overrideExisting: 'throw',
});

export const {
  useFetchObservationLinkedItemsQuery,
  useLazyFetchCommonObservationQuery,
  useImportObservationsMutation,
  useDownloadObservationsImportTemplateMutation,
} = observationsApi;
